import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import DailyDeviationIndicator from '@wix/da-ds/pkg/Indicators/DailyDeviationIndicator';
import ThumbStatusIndicators from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicators';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getIsUserSubscribed } from '../../../_helpers';
import { useIsCurrentUserDeviationAuthor } from '../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import s from './DeviationThumbIndicators.scss';
function getIndicators(deviation) {
    const indicators = [];
    if (deviation.primaryTier) {
        indicators.push('in-tier');
    }
    const { isWatchToAccess , isPaidFolder  } = normalizePremiumFolderData(deviation.premiumFolderData);
    if (isPaidFolder) {
        indicators.push('premium-folder');
    }
    if (isWatchToAccess) {
        indicators.push('watchers-only-folder');
    }
    if (deviation.commission) {
        indicators.push('commission');
    }
    if (deviation.isAdoptable) {
        indicators.push('adoptable');
    }
    return indicators;
}
const DeviationThumbIndicators = ({ className , deviation  })=>{
    var _getIndicators;
    const { t  } = useTranslation();
    const { showDailyDeviationLabel , showThumbStatusIndicators  } = useOverlayContext(deviation);
    const isOwner = useIsCurrentUserDeviationAuthor(deviation);
    const showDailyDeviation = deviation.isDailyDeviation && showDailyDeviationLabel;
    const indicators = showThumbStatusIndicators ? (_getIndicators = getIndicators(deviation)) === null || _getIndicators === void 0 ? void 0 : _getIndicators.slice(0, showDailyDeviation ? 2 : 3) : [];
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, showDailyDeviation && /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t('thumb.tooltip.dailyDeviation'),
        usePortal: true
    }, /*#__PURE__*/ React.createElement(DailyDeviationIndicator, {
        size: "large",
        className: s['dd']
    })), /*#__PURE__*/ React.createElement(ThumbStatusIndicators, {
        className: s['status-indicators'],
        indicators: indicators.map((type)=>({
                type,
                tooltip: t(`thumb.tooltip.${type}`),
                hasAccess: getIsUserSubscribed(deviation) || isOwner
            }))
    }));
};
DeviationThumbIndicators.displayName = 'DeviationThumbIndicators';
export default DeviationThumbIndicators;
